const translation = {
    $code: 'it',
    $name: 'Italiano',
    $dir: 'ltr',
    validityRequired: 'Questo campo è obbligatorio.',
    validityGroupRequired: "Scegli almeno un'opzione",
    validityPattern: 'Il valore non corrisponde al formato richiesto.',
    validityMinlength: 'Il valore deve essere lungo almeno {minlength} caratteri.',
    validityMaxlength: 'Il valore deve essere lungo al massimo {maxlength} caratteri.',
};
export default translation;
//# sourceMappingURL=it.js.map